import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';

@Component({
  selector: 'app-campus-facilities',
  templateUrl: './campus-facilities.component.html',
  styleUrls: ['./campus-facilities.component.scss']
})
export class CampusFacilitiesComponent implements OnInit, OnDestroy {

  facilities = [
    {
      name: 'BAJMC Lab',
      thumbs: [
        '/assets/img/facilities/imgi_4_BAJMC_1-600x400.jpg',
        '/assets/img/facilities/imgi_5_BAJMC_3-533x400.jpg',
        '/assets/img/facilities/imgi_6_BAJMC_2-600x400.jpg',
      ]
    },
    {
      name: 'CDC Room',
      thumbs: [
        '/assets/img/facilities/imgi_7_cdc_room1-600x400.jpg',
        '/assets/img/facilities/imgi_8_CDC_room_new_img1-735x400.jpg',
        '/assets/img/facilities/imgi_9_CDC_room_new_img2-533x400.jpg',
        '/assets/img/facilities/imgi_10_CDC_room_new_img3-533x400.jpg',
        '/assets/img/facilities/imgi_11_cdc_room4-600x400.jpg',
        '/assets/img/facilities/imgi_12_cdc_room3-600x400.jpg',
        '/assets/img/facilities/imgi_13_cdc_room2-600x400.jpg',
      ]
    },
    {
      name: 'Class Room',
      thumbs: [
        '/assets/img/facilities/imgi_14_class_room_img2-600x400.jpg',
        '/assets/img/facilities/imgi_15_class_room_img1-600x400.jpg',
      ]
    },
    {
      name: 'Chemistry Lab',
      thumbs: [
        '/assets/img/facilities/imgi_16_chemistry_lab_img-600x400.jpg',
        '/assets/img/facilities/imgi_17_chemistry_lab_img12-600x400.jpg',
        '/assets/img/facilities/imgi_18_chemistry_lab_img14-600x400.jpg',
        '/assets/img/facilities/imgi_19_chemistry_lab_img10-600x400.jpg',
        '/assets/img/facilities/imgi_20_chemistry_lab_img11-600x400.jpg',
        '/assets/img/facilities/imgi_21_chemistry_lab_img9-600x400.jpg',
        '/assets/img/facilities/imgi_22_chemistry_lab_img8-600x400.jpg',
        '/assets/img/facilities/imgi_23_chemistry_lab_img7-600x400.jpg',
        '/assets/img/facilities/imgi_24_chemistry_lab_img6-600x400.jpg',
        '/assets/img/facilities/imgi_25_chemistry_lab_img5-600x400.jpg',
        '/assets/img/facilities/imgi_26_chemistry_lab_img4-600x400.jpg',
        '/assets/img/facilities/imgi_27_chemistry_lab_img3-600x400.jpg',
        '/assets/img/facilities/imgi_28_chemistry_lab_img2-600x400.jpg',
        '/assets/img/facilities/imgi_29_chemistry_lab_img1-600x400.jpg',
      ]
    },
    {
      name: 'Computer Lab',
      thumbs: [
        '/assets/img/facilities/imgi_30_computer_lab_image-600x400.jpg',
        '/assets/img/facilities/imgi_31_computer_lab_img20-600x400.jpg',
        '/assets/img/facilities/imgi_32_computer_lab_img19-600x400.jpg',
        '/assets/img/facilities/imgi_33_computer_lab_img18-600x400.jpg',
        '/assets/img/facilities/imgi_34_computer_lab_img17-600x400.jpg',
        '/assets/img/facilities/imgi_35_computer_lab_img16-600x400.jpg',
        '/assets/img/facilities/imgi_36_computer_lab_img15-600x400.jpg',
        '/assets/img/facilities/imgi_37_computer_lab_img14-600x400.jpg',
        '/assets/img/facilities/imgi_38_computer_lab_img12-600x400.jpg',
        '/assets/img/facilities/imgi_39_computer_lab_img11-600x400.jpg',
        '/assets/img/facilities/imgi_40_computer_lab_img10-600x400.jpg',
        '/assets/img/facilities/imgi_41_computer_lab_img9-600x400.jpg',
        '/assets/img/facilities/imgi_42_computer_lab_img8-600x400.jpg',
        '/assets/img/facilities/imgi_43_computer_lab_img7-600x400.jpg',
        '/assets/img/facilities/imgi_44_computer_lab_img6-600x400.jpg',
        '/assets/img/facilities/imgi_45_computer_lab_img5-600x400.jpg',
        '/assets/img/facilities/imgi_46_computer_lab_img4-600x400.jpg',
        '/assets/img/facilities/imgi_47_computer_lab_img3-600x400.jpg',
        '/assets/img/facilities/imgi_48_computer_lab_img2-600x400.jpg',
        '/assets/img/facilities/imgi_49_computer_lab_img1-600x400.jpg',
        '/assets/img/facilities/imgi_50_computer_lab_img-600x400.jpg',
      ]
    },
    {
      name: 'Dance and Music Room',
      thumbs: [
        '/assets/img/facilities/imgi_51_dance_music_img4-600x400.jpg',
        '/assets/img/facilities/imgi_52_dance_music_img3-600x400.jpg',
        '/assets/img/facilities/imgi_53_dance_music_img2-600x400.jpg',
        '/assets/img/facilities/imgi_54_dance_music_img1-600x400.jpg',
      ]
    },
    {
      name: 'Geography Lab',
      thumbs: [
        '/assets/img/facilities/imgi_57_geography_lab_img-600x400.jpg',
        '/assets/img/facilities/imgi_58_geography_lab_img16-500x400.jpg',
        '/assets/img/facilities/imgi_59_geography_lab_img15-533x400.jpg',
        '/assets/img/facilities/imgi_60_geography_lab_img14-533x400.jpg',
        '/assets/img/facilities/imgi_61_geography_lab_img12-600x400.jpg',
        '/assets/img/facilities/imgi_62_geography_lab_img11-600x400.jpg',
        '/assets/img/facilities/imgi_63_geography_lab_img10-600x400.jpg',
        '/assets/img/facilities/imgi_64_geography_lab_img9-600x400.jpg',
        '/assets/img/facilities/imgi_65_geography_lab_img8-600x400.jpg',
        '/assets/img/facilities/imgi_66_geography_lab_img7-600x400.jpg',
        '/assets/img/facilities/imgi_67_geography_lab_img6-600x400.jpg',
        '/assets/img/facilities/imgi_68_geography_lab_img5-600x400.jpg',
        '/assets/img/facilities/imgi_69_geography_lab_img4-600x400.jpg',
        '/assets/img/facilities/imgi_70_geography_lab_img3-600x400.jpg',
        '/assets/img/facilities/imgi_71_geography_lab_img2-600x400.jpg',
        '/assets/img/facilities/imgi_72_geography_lab_img1-600x400.jpg',
      ]
    },
    {
      name: 'Home Science Lab',
      thumbs: [
        '/assets/img/facilities/imgi_73_home_science_lab3-747x400.jpg',
        '/assets/img/facilities/imgi_74_home_science_lab4-600x400.jpg',
        '/assets/img/facilities/imgi_75_home_science_lab2-533x400.jpg',
        '/assets/img/facilities/imgi_76_home_science_lab1-533x400.jpg',
        '/assets/img/facilities/imgi_77_home_science_lab6-600x400.jpg',
        '/assets/img/facilities/imgi_78_home_science_lab7-600x400.jpg',
        '/assets/img/facilities/imgi_79_home_science_lab8-600x400.jpg',
        '/assets/img/facilities/imgi_80_home_science_lab9-500x400.jpg',
        '/assets/img/facilities/imgi_81_home_science_lab5-600x400.jpg',
      ]
    },
    {
      name: 'Physical Education Lab',
      thumbs: [
        '/assets/img/facilities/imgi_82_physical_education_lab_img1-600x400.jpg',
        '/assets/img/facilities/imgi_83_physical_education_lab_img2-600x400.jpg',
      ]
    },
    {
      name: 'Physics Lab',
      thumbs: [
        '/assets/img/facilities/imgi_84_physics_lab_img1-600x400.jpg',
        '/assets/img/facilities/imgi_85_physics_lab_img23-533x400.jpg',
        '/assets/img/facilities/imgi_86_physics_lab_img21-600x400.jpg',
        '/assets/img/facilities/imgi_87_physics_lab_img20-600x400.jpg',
        '/assets/img/facilities/imgi_88_physics_lab_img18-600x400.jpg',
        '/assets/img/facilities/imgi_89_physics_lab_img19-600x400.jpg',
        '/assets/img/facilities/imgi_90_physics_lab_img22-600x400.jpg',
        '/assets/img/facilities/imgi_91_physics_lab_img17-600x400.jpg',
        '/assets/img/facilities/imgi_92_physics_lab_img16-600x400.jpg',
        '/assets/img/facilities/imgi_93_physics_lab_img15-600x400.jpg',
        '/assets/img/facilities/imgi_94_physics_lab_img14-600x400.jpg',
        '/assets/img/facilities/imgi_95_physics_lab_img12-600x400.jpg',
        '/assets/img/facilities/imgi_96_physics_lab_img9-600x400.jpg',
        '/assets/img/facilities/imgi_97_physics_lab_img10-600x400.jpg',
        '/assets/img/facilities/imgi_98_physics_lab_img11-600x400.jpg',
        '/assets/img/facilities/imgi_99_physics_lab_img8-600x400.jpg',
        '/assets/img/facilities/imgi_100_physics_lab_img6-600x400.jpg',
        '/assets/img/facilities/imgi_101_physics_lab_img7-600x400.jpg',
        '/assets/img/facilities/imgi_102_physics_lab_img4-600x400.jpg',
        '/assets/img/facilities/imgi_103_physics_lab_img5-600x400.jpg',
        '/assets/img/facilities/imgi_104_physics_lab_img2-600x400.jpg',
        '/assets/img/facilities/imgi_105_physics_lab_img3-600x400.jpg',
        '/assets/img/facilities/imgi_106_physics_lab_img-600x400.jpg',
      ]
    },
    {
      name: 'Psychology Lab',
      thumbs: [
        '/assets/img/facilities/imgi_107_psychology_lab_img1-600x400.jpg',
        '/assets/img/facilities/imgi_108_psychology_lab_img3-600x400.jpg',
        '/assets/img/facilities/imgi_109_psychology_lab_img5-533x400.jpg',
        '/assets/img/facilities/imgi_110_psychology_lab_img4-533x400.jpg',
        '/assets/img/facilities/imgi_111_psychology_lab_img2-600x400.jpg',
      ]
    },
    {
      name: 'Staff Room',
      thumbs: [
        '/assets/img/facilities/imgi_112_staff_img10-533x400.jpg',
        '/assets/img/facilities/imgi_113_staff_img1-1-600x400.jpg',
        '/assets/img/facilities/imgi_114_staff_img8-600x400.jpg',
        '/assets/img/facilities/imgi_115_staff_img2-1-600x400.jpg',
        '/assets/img/facilities/imgi_116_staff_img7-600x400.jpg',
        '/assets/img/facilities/imgi_117_staff_img6-661x400.jpg',
        '/assets/img/facilities/imgi_118_staff_img9-533x400.jpg',
        '/assets/img/facilities/imgi_119_staff_img5-600x400.jpg',
        '/assets/img/facilities/imgi_120_staff_img4-600x400.jpg',
        '/assets/img/facilities/imgi_121_staff_img3-600x400.jpg',
        '/assets/img/facilities/imgi_122_staff_img2-600x400.jpg',
        '/assets/img/facilities/imgi_123_staff_img1-600x400.jpg',
        '/assets/img/facilities/imgi_124_staff_image-1-600x400.jpg',
        '/assets/img/facilities/imgi_125_staff_img11-533x400.jpg',
      ]
    },
  ];

  // Lightbox State
  isLightboxOpen = false;
  activeFolderIndex = 0;
  activeImageIndex = 0;

  constructor() { }

  ngOnInit(): void { }

  ngOnDestroy(): void { }

  openFolder(folderIndex: number): void {
    this.activeFolderIndex = folderIndex;
    this.activeImageIndex = 0;
    this.isLightboxOpen = true;
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  }

  closeLightbox(): void {
    this.isLightboxOpen = false;
    document.body.style.overflow = ''; // Restore background scrolling
  }

  prevImage(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    const totalImages = this.facilities[this.activeFolderIndex].thumbs.length;
    this.activeImageIndex = (this.activeImageIndex - 1 + totalImages) % totalImages;
  }

  nextImage(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    const totalImages = this.facilities[this.activeFolderIndex].thumbs.length;
    this.activeImageIndex = (this.activeImageIndex + 1) % totalImages;
  }

  setImageIndex(index: number, event: MouseEvent): void {
    event.stopPropagation();
    this.activeImageIndex = index;
  }

  // Keyboard navigation listeners
  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    if (!this.isLightboxOpen) return;

    if (event.key === 'ArrowLeft') {
      this.prevImage();
    } else if (event.key === 'ArrowRight') {
      this.nextImage();
    } else if (event.key === 'Escape') {
      this.closeLightbox();
    }
  }
}
